export const DialogState = Object.freeze({
  LOADING: 'LOADING',
  INSTALLED: 'INSTALLED',
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED',
  REQUESTABLE: 'REQUESTABLE',
  ERROR: 'ERROR'
});